var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination"},[_c('PerPage',{attrs:{"value":_vm.perPage},on:{"change":_vm.onChangePerPage}}),_c('NavPaging',{attrs:{"lastPage":_vm.lastPage,"currentPage":_vm.currentPage},on:{"navigate":_vm.navigate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }